import React from "react";
import { VALIDITY_META } from "./vocab";

function describe(meta) {
    const parts = [];
    if (meta?.valid_from) parts.push(`from ${meta.valid_from}`);
    if (meta?.valid_to) parts.push(`to ${meta.valid_to}`);
    if (meta?.expires_at && meta.expires_at !== meta.valid_to) parts.push(`expires ${meta.expires_at}`);
    if (meta?.irb_approved === true) parts.push(`IRB approved${meta.irb_approval_date ? ` ${meta.irb_approval_date}` : ""}${meta.irb_name ? ` (${meta.irb_name})` : ""}`);
    if (meta?.irb_approved === false) parts.push("IRB not approved");
    if (meta?.status) parts.push(meta.status);
    return parts.join(" · ") || "no validity dates set";
}

export function ValidityChip({ state, meta, itemId, showDate = false }) {
    const v = VALIDITY_META[state || "valid"] || VALIDITY_META.valid;
    const expiry = meta?.effective_expiry || meta?.expires_at || meta?.valid_to;
    return (
        <span data-testid={`dl-validity-${itemId}`} title={describe(meta)}
            className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-sm border text-[10px] font-mono whitespace-nowrap ${v.tone}`}>
            <span className="w-1.5 h-1.5 rounded-full bg-current" /> {v.label}
            {showDate && expiry && <span className="opacity-70">· {expiry}</span>}
        </span>
    );
}
